import { render, staticRenderFns } from "./LocalesNode.vue?vue&type=template&id=17d10e7e&scoped=true"
import script from "./LocalesNode.vue?vue&type=script&lang=js"
export * from "./LocalesNode.vue?vue&type=script&lang=js"
import style0 from "./LocalesNode.vue?vue&type=style&index=0&id=17d10e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d10e7e",
  null
  
)

export default component.exports